import React, { useEffect, useState } from 'react';
import { Button, TextField, Spinner, Text, Flex, DataList, Card, Heading } from "@radix-ui/themes"
import { useFormik } from 'formik'
import * as Yup from 'yup'
import { updateUserDetails } from '../../redux/slices/userSlice'
import api from '../../api'
import { useSelector, useDispatch } from 'react-redux';
import { toast } from 'react-toastify';
const GeneralInfoProfileForm = ({ setIsEditing }) => {
    const [loading, setLoading] = useState(false);
    const dispatch = useDispatch();
    const userDetails = useSelector((state) => state.user.details);

    useEffect(() => {
        console.log('user-details::', userDetails)
        formik.setValues({
            firstName: userDetails?.firstname || '',
            lastName: userDetails?.lastname || '',
            country_code: userDetails?.country_code || '233',
            phone: userDetails?.phone || '',
        })
    }, [userDetails])

    const formik = useFormik({
        initialValues: {
            firstName: userDetails?.firstname || '',
            lastName: userDetails?.lastname || '',
            email: userDetails?.email || '',
            phone: userDetails?.phone || '',
            country_code: userDetails?.country_code || '233',
        },
        validationSchema: Yup.object({
            firstName: Yup.string().required('First name is required'),
            lastName: Yup.string().required('Last name is required'),
            email: Yup.string()
                .email('Invalid email')
            ,
            country_code: Yup.string()
                .matches(/^[0-9]{3,4}$/, 'Country code must be between 3 and 4 digits')
            ,
            phone: Yup.string()
                .matches(/^[0-9]{7,10}$/, 'Phone number must be between 7 and 10 digits')
            ,
        }),
        onSubmit: async (values) => {
            try {
                formik.setStatus('')
                setLoading(true)
                const userData = {
                    firstname: values.firstName,
                    lastname: values.lastName,
                    email: values.email,
                    country_code: values.country_code,
                    phone: values.phone,
                }

                const response = await api.put(`/user/profile`, userData)
                const data = response.data

                if (data.errors) {
                    formik.setErrors(data.errors)
                } else {
                    dispatch(updateUserDetails(data.userDetails));
                    localStorage.setItem('userDetails', JSON.stringify(data.userDetails))
                    toast.success(data.message, {
                        position: "bottom-right"
                    })
                    setIsEditing(false)
                }
            } catch (err) {
                console.log('check errors::', err.response.data.errors)
                if (err.response.data.errors) {
                    formik.setErrors(err.response.data.errors)
                }
                formik.setStatus('Update failed. Please try again.')
            } finally {
                setLoading(false)
            }
        }
    })


    return (
        <form form onSubmit={formik.handleSubmit}>
            <DataList.Root>
                <DataList.Item>
                    <DataList.Label minWidth="100px">Firstname</DataList.Label>
                    <DataList.Value>
                        <Flex direction="column" gap="1">
                            <TextField.Root size="3"
                                name="firstName"
                                value={formik.values.firstName}
                                onChange={formik.handleChange}
                                onBlur={formik.handleBlur}
                                placeholder="First Name"
                            />
                            {formik.touched.firstName && formik.errors.firstName &&
                                <Text color="red" size="2">{formik.errors.firstName}</Text>
                            }
                        </Flex>
                    </DataList.Value>
                </DataList.Item>

                <DataList.Item>
                    <DataList.Label minWidth="100px">Lastname</DataList.Label>
                    <DataList.Value>
                        <Flex direction="column" gap="1">
                            <TextField.Root size="3"
                                name="lastName"
                                value={formik.values.lastName}
                                onChange={formik.handleChange}
                                onBlur={formik.handleBlur}
                                placeholder="Last Name"
                            />
                            {formik.touched.lastName && formik.errors.lastName &&
                                <Text color="red" size="2">{formik.errors.lastName}</Text>
                            }
                        </Flex>
                    </DataList.Value>
                </DataList.Item>

                <DataList.Item>
                    <DataList.Label minWidth="100px">Email</DataList.Label>
                    <DataList.Value>
                        <Flex direction="column" gap="1">
                            <TextField.Root size="3"
                                name="email"
                                value={formik.values.email}
                                onChange={formik.handleChange}
                                onBlur={formik.handleBlur}
                                placeholder="Email Address"
                            />
                            {formik.touched.email && formik.errors.email &&
                                <Text color="red" size="2">{formik.errors.email}</Text>
                            }
                        </Flex>
                    </DataList.Value>
                </DataList.Item>
            </DataList.Root>
            <Flex direction="row" justify="between" align="center">

                <Button>Save</Button>
            </Flex>
        </form>
    )

};

export default GeneralInfoProfileForm;
